import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { computed, defineComponent, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import NotificationService from "@/services/notification.service";
import { ModalStatus } from "@/constants/modal";
import { LogService } from "@/services/logging";
import ScannerModule from "@/store/modules/scanner";
import { getPSSWithToken, getMembershipTokenByVoucherCode } from "@/api/gql/product-slot-state";
import ModalModule from "@/store/modules/modal";
import { selectOrderForEditing } from "@/utils/vue-helpers/orders";
import { extractCodeFromUrl } from "@/utils/vue-helpers/promocode";
export default defineComponent({
  name: "ScanQrCode",
  components: {},
  setup: function setup() {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var loading = ref(false);
    var modalVisibility = dialogVisibleForStatus(ModalStatus.ScanQrCode); // scanner

    var ScannerTog = computed(function () {
      return ScannerModule.tog;
    });
    watch(ScannerTog, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var scannedPSSQRCode, scannedPSSToken, isUrl, code, membershipToken, scannedJsonCode, fetchedPSS, bookingId;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(ScannerModule.value && modalVisibility.value)) {
                _context.next = 39;
                break;
              }

              loading.value = true;
              scannedPSSQRCode = ScannerModule.value;
              scannedPSSToken = scannedPSSQRCode;
              LogService.info("QR Code: PSS QRCode scanned = ".concat(scannedPSSQRCode));
              _context.prev = 5;
              isUrl = String(scannedPSSQRCode).startsWith("http://") || String(scannedPSSQRCode).startsWith("https://") || String(scannedPSSQRCode).startsWith("http//") || String(scannedPSSQRCode).startsWith("https//");

              if (!isUrl) {
                _context.next = 25;
                break;
              }

              LogService.info("QR Code: scanned value is in url format"); // We need to extract the voucher code from the url scanned, then try to pull the curresponding membership ticket.

              code = extractCodeFromUrl(ScannerModule.value);
              LogService.info("QR Code: Voucher code extracted from qrcode string code: ".concat(code));

              if (!(code && code.length >= 5)) {
                _context.next = 23;
                break;
              }

              LogService.info("QR Code: going to fetch the token of the membership ticket with code: ".concat(code));
              _context.next = 15;
              return getMembershipTokenByVoucherCode(code);

            case 15:
              membershipToken = _context.sent;

              if (!membershipToken) {
                _context.next = 21;
                break;
              }

              LogService.info("QR Code: got membership token from scanned voucher code", {
                membershipToken: membershipToken
              });
              scannedPSSToken = membershipToken;
              _context.next = 23;
              break;

            case 21:
              LogService.info("QR Code: no membership token was found for scanned voucher code", {
                code: code
              });
              throw new Error("No membership token was found");

            case 23:
              _context.next = 26;
              break;

            case 25:
              // Check if the scanned qr code has the new json format of membership tickets.
              // Try to parse the QR code as JSON.
              try {
                scannedJsonCode = JSON.parse(scannedPSSQRCode);

                if (scannedJsonCode && scannedJsonCode.code && scannedJsonCode.token) {
                  LogService.info("QR Code: scanned token is a membership ticket with json format.", {
                    params: scannedJsonCode
                  });
                  scannedPSSToken = scannedJsonCode.token;
                }
              } catch (parseError) {
                // If JSON.parse fails, let's handle the QR code as if it's a normal token.
                LogService.info("QR Code: scanned token is a normal ticket.");
              }

            case 26:
              _context.next = 28;
              return getPSSWithToken(scannedPSSToken);

            case 28:
              fetchedPSS = _context.sent;

              if (fetchedPSS) {
                bookingId = fetchedPSS.BookingId;

                if (bookingId) {
                  LogService.info("QR Code: got booking from scanned PSS token", {
                    bookingId: bookingId
                  });
                  NotificationService.showCustomSuccess(t("qrcode.success"));
                  ModalModule.setStatus(ModalStatus.Hidden);
                  selectOrderForEditing({
                    id: bookingId.toString()
                  });
                } else {
                  LogService.info("QR Code: no booking was found for fetched PSS", {
                    fetchedPSS: fetchedPSS
                  });
                }
              }

              _context.next = 36;
              break;

            case 32:
              _context.prev = 32;
              _context.t0 = _context["catch"](5);
              LogService.info("QR Code: Failed to fetch PSS", {
                scannedPSS: scannedPSSToken
              });
              NotificationService.showCustomError(t("qrcode.error"));

            case 36:
              _context.prev = 36;
              loading.value = false;
              return _context.finish(36);

            case 39:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 32, 36, 39]]);
    })), {
      deep: true
    });
    return {
      t: t,
      loading: loading,
      modalVisibility: modalVisibility
    };
  }
});